export const capitalize = (str) => {
  const firstLetter = str[0].toUpperCase();
  const rest = str.slice(1).toLowerCase();
  return firstLetter + rest;
};

export const downloadCSV = (csvData) => {
  const element = document.createElement("a");
  const file = new Blob([csvData], { type: "text/plain " });

  element.href = URL.createObjectURL(file);
  element.download = "SV Game Export.csv";
  document.body.appendChild(element);
  element.click();
};

export const colors = {
  forest: ["#93c47d", "#38761d"],
  sword: ["#ffd966", "#bf9000"],
  rune: ["#6fa8dc", "#0b5394"],
  haven: ["#c27ba0", "#741b47"],
  shadow: ["#8e7cc3", "#351c75"],
  dragon: ["#f6b26b", "#b45f06"],
  blood: ["#e06666", "#990000"],
  portal: ["#76a5af", "#134f5c"]
};

export const crafts = [
  "forest",
  "sword",
  "rune",
  "dragon",
  "shadow",
  "blood",
  "haven",
  "portal"
];

/* eslint-disable */
export const darkenColor = (col, amt) => {
  const colorCode = col.slice(1);
  const num = parseInt(colorCode, 16);
  const r = (num >> 16) + amt;
  const b = ((num >> 8) & 0x00ff) + amt;
  const g = (num & 0x0000ff) + amt;
  const newColor = g | (b << 8) | (r << 16);
  return `#${newColor.toString(16)}`;
};
/* eslint-enable */
